import type { ReactNode } from "react";
import { Box } from "@mui/joy";
import DarkTypography from "components/common/DarkTypography";
import { colorTokens } from "styles/globalStyles";
import SmsStatusIcon from "./SmsStatusIcon";
import { smsStatusMeta } from "./smsStatusMeta";

type SmsStatusRowProps = {
  status: string;
  title: string;
  subtitle?: ReactNode;
  error?: string;
};

export default function SmsStatusRow({ status, title, subtitle, error }: SmsStatusRowProps) {
  const meta = smsStatusMeta(status);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.25,
        minWidth: 0,
        py: 0.75,
        px: { xs: 0.75, sm: 1 },
        borderBottom: `1px solid ${colorTokens.border.default}`,
        "&:last-of-type": { borderBottom: "none" },
      }}
    >
      <SmsStatusIcon status={status} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <DarkTypography
          level="body-sm"
          colorVariant="primary"
          sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
        >
          {title}
        </DarkTypography>
        {subtitle ? (
          <DarkTypography level="body-xs" colorVariant="muted" sx={{ overflowWrap: "anywhere" }}>
            {subtitle}
          </DarkTypography>
        ) : null}
        {error ? (
          <DarkTypography
            level="body-xs"
            sx={{ color: colorTokens.status.danger, overflowWrap: "anywhere" }}
          >
            {error}
          </DarkTypography>
        ) : null}
      </Box>
      <DarkTypography
        level="body-xs"
        sx={{ color: meta.color, flexShrink: 0, textAlign: "right", maxWidth: "40%" }}
      >
        {meta.label}
      </DarkTypography>
    </Box>
  );
}
